import { Helmet } from "react-helmet-async";

const KEYWORDS =
  "corporate strategy, global consulting, consulting, minerals, mining, oil and gas, Dugavu Ventures";
const SITE_NAME = "Dugavu Ventures";

export default function SEOMeta({ title, description, url }) {
  const fullTitle = `${title} | ${SITE_NAME}`;
  const canonical = `https://dugavuventures.com${url}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={KEYWORDS} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
}
